/** Release could not be confirmed; replacement input must remain blocked. */
export class MacroInputReleaseError extends Error {
  public readonly name = 'MacroInputReleaseError';
  public constructor(device: 'keyboard' | 'mouse' | 'gamepad' | 'touch' | 'mode' | 'filters') {
    super(`Macro ${device} release unconfirmed`);
  }
}
